import { render } from "./parte5.vue?vue&type=template&id=1563d9e0&scoped=true"
import script from "./parte5.vue?vue&type=script&lang=js"
export * from "./parte5.vue?vue&type=script&lang=js"

import "./parte5.vue?vue&type=style&index=0&id=1563d9e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1563d9e0"]])

export default __exports__